"use strict";

var AbstractValidator;

module.exports = AbstractValidator = (function () {
  function AbstractValidator(options) {
    this.options = options;
  }

  return AbstractValidator;
})();


/*****************
 ** WEBPACK FOOTER
 ** ./lib/validators/Abstract.js
 ** module id = 595
 ** module chunks = 0
 **/